import React from 'react';
import { useSelector,useDispatch } from 'react-redux'
import renderHTML from 'react-render-html';
import _toArray from "lodash-es/toArray";
import { DoneHoc, EditHoc, InfoIconHoc, StatusHoc } from '../../../assets/images';
import "../../../assets/scss/minEmoji.scss";
import {
    REACT_APP_PROFILE_NAME_CHAR,
    REACT_APP_STATUS_CHAR,
    VIEW_PROFILE_INFO,
    // YOUR_STATUS
} from '../../../processENV';
import {
     removeMoreNumberChar,
    } from "../../../Helpers/Chat/ContentEditableEle"
import SDK from '../../../SDK';
import { addVCardData } from '../../../Redux/feature/userDataSlice';
import { formatUserIdToJid } from '../../../Helpers/Chat/User';
import {toast} from 'react-toastify';
import { blockOfflineAction, validEmail } from '../../../Helpers/Utility';
import CustomIcon from '../../../assets/images/CustomIcon';

const WebChatFields = (props = {}) => {
    const store = useSelector(state => state)
    const {mf_Done, mf_Edit , mf_InfoIcon, mf_Status }=store?.dynamicIcon?.data;
    const { data:vCardData } = store?.vCardData
    const dispatch = useDispatch()
    const [webChatFieldsState, setWebChatFieldsState] = React.useState({
        userName: vCardData?.nickName,
        userStatus: vCardData?.status,
        userEmail: vCardData?.email,
        userMobile: vCardData?.mobileNumber,
        viewEdit: true,
        // viewEditStatus: true,
        viewEditEmail: true,
        viewEditMobile: true,
        viewTick: true,
        // viewTickStatus: true,
        viewTickEmail: true,
        viewTickMobile: true,
        charCount: false,
        // charCountStatus: false,
        charCountEmail: false,
        charCountMobile: false,
        userNameChars: REACT_APP_PROFILE_NAME_CHAR - vCardData?.nickName.length <= 0 ? 0 : REACT_APP_PROFILE_NAME_CHAR - vCardData?.nickName.length,
        statusChars: REACT_APP_STATUS_CHAR,
        lastUserName: 'Prabhu',
        // lastUserStatus: 'I am in Mirror Fly???',
        lastUserEmail:""
    });

    const { 
        userName,
        userStatus,
        userEmail,
        userMobile,
        viewEdit,
        // viewEditStatus,
        viewEditEmail,
        viewEditMobile,
        viewTick,
        // viewTickStatus,
        viewTickEmail,
        viewTickMobile,
        charCount,
        // charCountStatus,
        charCountEmail,
        charCountMobile,
        userNameChars,
        statusChars,
        lastUserName,
        lastUserEmail
        // lastUserStatus
    } = webChatFieldsState;

    React.useEffect(()=>{
        setWebChatFieldsState({
            ...webChatFieldsState,
            userName: vCardData?.nickName,
            userEmail: vCardData?.email,
            userMobile: vCardData?.mobileNumber
        })
    },[])

    const findNegativeValue = (message = "", lengthData = 0) => {
        const groupNameLength = lengthData - _toArray(message).length;
        if (groupNameLength >= 0) {
            return lengthData - _toArray(message).length;
        }
        return 0;
    };
    
    const vcardDataDispatch = async() => {
        const userProfile = await SDK.getUserProfile(formatUserIdToJid(vCardData?.fromUser));
        if(userProfile && userProfile.statusCode === 200){
            dispatch(addVCardData(userProfile.data))
        }
    }

    /**
     * handleVcardSaveUsername() method to store username for view profile.
     */
    const handleVcardSaveUsername = async (e) => {
        if (blockOfflineAction()) return;
        const getUserName = userName.trim();
        if (getUserName.length < 3) {
            toast.error('Username is too short');
            return ;
        }
        if (getUserName !== "") {
            let mobileno = vCardData?.fromUser || "";
            let profileImage = "";
            if(vCardData.thumbImage !== "") profileImage = vCardData.thumbImage;
            else profileImage = vCardData.image;
            const isUserNameChanged = lastUserName !== getUserName;
            let response = isUserNameChanged ? await SDK.setUserProfile(getUserName, profileImage, vCardData.status, mobileno, vCardData.email) : {};
            if (response.statusCode === 200 || !isUserNameChanged) {
            setWebChatFieldsState({
                ...webChatFieldsState,
                userNameChars: "",
                viewEdit: true,
                charCount: false,
                viewTick: true,
                userName: getUserName,
                userStatus: userStatus
            });
            isUserNameChanged && toast.success('Profile updated successfully');
           await vcardDataDispatch();
            } 
            else {
                toast.error(response.message);
            }
        }
    }

    const handleEdit = () => {
        if (blockOfflineAction()) return;
        const message = removeMoreNumberChar(REACT_APP_PROFILE_NAME_CHAR, webChatFieldsState.userName);
        const charLeft = findNegativeValue(message, REACT_APP_PROFILE_NAME_CHAR);
        setWebChatFieldsState({ ...webChatFieldsState, viewEdit: false, viewTick: false, charCount: true, lastUserName: userName, userNameChars: charLeft <= 0 ? 0 : charLeft });
    };
    /**
    // const handleWordCountStatus = (event ={}) => {
    //     const getStatus = event.target.value;
    //     const message = removeMoreNumberChar(REACT_APP_STATUS_CHAR, getStatus);
    //     const charLeft = findNegativeValue(message, REACT_APP_STATUS_CHAR);
    //     setWebChatFieldsState({
    //         ...webChatFieldsState,
    //         userStatus:getStatus,
    //         statusChars: charLeft <= 0 ? 0 : charLeft
    //         })
    //  };
    */
    /**
     * handleVcardSaveStatus() method to store status for view profile.
     */
    /**
    //  const handleVcardSaveStatus = async (e) => {
    //     if (blockOfflineAction()) return;
    //     const newUserStatus = userStatus.trim();
    //     if (newUserStatus !== "") {
    //         let mobileno = vCardData.mobileNumber;
    //         const isUserStatusChanged = lastUserStatus !== newUserStatus;
    //         let response = isUserStatusChanged ? await SDK.setUserProfile(vCardData.nickName, vCardData.image, newUserStatus, mobileno, vCardData.email) : {};
    //         if (response.statusCode === 200 || !isUserStatusChanged) {
    //             setWebChatFieldsState({ ...webChatFieldsState,
    //                 statusChars: "",
    //                 viewEditStatus: true,
    //                 charCountStatus: false,
    //                 viewTickStatus: true,
    //                 userStatus:newUserStatus.trim(),
    //             });
    //             isUserStatusChanged && toast.success('Profile updated successfully');
    //             await vcardDataDispatch()
    //         } else {
    //             toast.error(response.message);
    //         }
    //     }
    // }
    */


    /**
      * handleEditStatus() method to maintain state for Edit status field.
      */
    /**
    // const handleEditStatus = (e = {}) => {
    //     if (blockOfflineAction()) return;
    //     const message = removeMoreNumberChar(REACT_APP_STATUS_CHAR, webChatFieldsState.userStatus);
    //     const charLeft = findNegativeValue(message, REACT_APP_STATUS_CHAR);
    //     setWebChatFieldsState({ ...webChatFieldsState, viewEditStatus: false, viewTickStatus: false, charCountStatus: true, lastUserStatus: userStatus,statusChars: charLeft <= 0 ? 0 : charLeft });
    // }
    */

    const handleWordCount = (event ={}) => {
        const getUserName = event.target.value;
        const message = removeMoreNumberChar(REACT_APP_PROFILE_NAME_CHAR, getUserName);
        const charLeft = findNegativeValue(message, REACT_APP_PROFILE_NAME_CHAR);
        setWebChatFieldsState({
            ...webChatFieldsState,
            userName:getUserName,
            userNameChars: charLeft <= 0 ? 0 : charLeft
        })
    }

    // ---Email
    const handleWordCountEmail = (event ={}) => {
        const getEmail = event.target.value;
        const message = removeMoreNumberChar(REACT_APP_STATUS_CHAR, getEmail);
        const charLeft = findNegativeValue(message, REACT_APP_STATUS_CHAR);
        setWebChatFieldsState({
            ...webChatFieldsState,
            userEmail:getEmail,
            statusChars: charLeft <= 0 ? 0 : charLeft
        })
    };
    /**
     * handleVcardSaveStatus() method to store status for view profile.
     */
     const handleVcardSaveEmail = async (e) => {
        if (blockOfflineAction()) return;
        const newUserEmail = userEmail.trim();
        const val_Email = validEmail(newUserEmail);
        let mobileno = vCardData?.fromUser || "";
        if (newUserEmail !== "" && val_Email) {
            const isUserEmailChanged = lastUserEmail !== newUserEmail;
            let response = isUserEmailChanged ? await SDK.setUserProfile(vCardData.nickName, vCardData.image, vCardData.status, mobileno, newUserEmail) : {};
            if (response.statusCode === 200 || !isUserEmailChanged) {
                setWebChatFieldsState({ ...webChatFieldsState,
                    statusChars: "",
                    viewEditEmail: true,
                    charCountEmail: false,
                    viewTickEmail: true,
                    userEmail:newUserEmail.trim(),
                });
                isUserEmailChanged && toast.success('Profile updated successfully');
                await vcardDataDispatch()
            } else {
                toast.error(response.message);
            }
        }else{
            toast.error("Please enter a valid email");
        }
    }

    /**
      * handleEditStatus() method to maintain state for Edit status field.
      */
    const handleEditEmail = (e = {}) => {
        if (blockOfflineAction()) return;
        const message = removeMoreNumberChar(REACT_APP_STATUS_CHAR, webChatFieldsState.userEmail);
        const charLeft = findNegativeValue(message, REACT_APP_STATUS_CHAR);
        setWebChatFieldsState({ ...webChatFieldsState, viewEditEmail: false, viewTickEmail: false, charCountEmail: true, lastUserEmail: userEmail,statusChars: charLeft <= 0 ? 0 : charLeft });
    }

    // ---Mobile
    const handleWordCountMobile = (event ={}) => {
        const getMobile = event.target.value;
        const message = removeMoreNumberChar(REACT_APP_STATUS_CHAR, getMobile);
        const charLeft = findNegativeValue(message, REACT_APP_STATUS_CHAR);
        setWebChatFieldsState({
            ...webChatFieldsState,
            userMobile:getMobile,
            statusChars: charLeft <= 0 ? 0 : charLeft
        })
    };
    /**
     * handleVcardSaveStatus() method to store status for view profile.
     */
     const handleVcardSaveMobile = async (e) => {
        if (blockOfflineAction()) return;
        const lastMobile = ""
        const newUserMobile = userMobile.trim();
        if (newUserMobile !== "") {
            const isUserMobileChanged = lastMobile !== newUserMobile;
            let response = isUserMobileChanged ? await SDK.setUserProfile(vCardData.nickName, vCardData.image, vCardData.status, newUserMobile, vCardData.email) : {};
            if (response.statusCode === 200 || !isUserMobileChanged) {
                setWebChatFieldsState({ ...webChatFieldsState,
                    statusChars: "",
                    viewEditMobile: true,
                    charCountMobile: false,
                    viewTickMobile: true,
                    userStatus:newUserMobile.trim(),
                });
                isUserMobileChanged && toast.success('Profile updated successfully');
                await vcardDataDispatch()
            } else {
                toast.error(response.message);
            }
        }
    }

    /**
      * handleEditStatus() method to maintain state for Edit status field.
      */
    /**
    // const handleEditMobile = (e = {}) => {
    //     if (blockOfflineAction()) return;
    //     const message = removeMoreNumberChar(REACT_APP_STATUS_CHAR, webChatFieldsState.userMobile);
    //     const charLeft = findNegativeValue(message, REACT_APP_STATUS_CHAR);
    //     setWebChatFieldsState({ ...webChatFieldsState, viewEditMobile: false, viewTickMobile: false, charCountMobile: true, lastUserStatus: userStatus,statusChars: charLeft <= 0 ? 0 : charLeft });
    // }
    */
    
    return (
        <>
            <div className="profile">
                <div className="profile-details username" title="Edit name">
                    <i className="status">
                        
                    <CustomIcon icon={mf_Status ? mf_Status : <StatusHoc />} {...props} /></i>
                    <div className="form-control">
                        {!viewEdit &&
                            <input
                                type="text"
                                autoComplete="off"
                                value={userName}
                                // maxLength={findNegativeValue(userName, REACT_APP_PROFILE_NAME_CHAR) > 0 ? 1000 : 0}
                                maxLength={REACT_APP_PROFILE_NAME_CHAR}
                                placeholder="Username"
                                id="username"
                                name="userName"
                                onChange={handleWordCount}
                                autoFocus
                            // onMouseUp={(e) => {
                            //     userNameCursorPostion = e.target.selectionStart;
                            // }}
                            // onKeyUp={(e) => {
                            //     userNameCursorPostion = e.target.selectionStart;
                            // }}
                            // onBlur={(e) => {
                            //     userNameSelectedText = getSelectedText();
                            // }}
                            ></input>
                        }
                        {charCount && <span className="char-count">
                            {userNameChars}
                        </span>}
                        {/** {!viewEdit && <i className="emoji">
                            <WebChatEmoji onEmojiClick={onEmojiClickUsername} />
                        </i>} */}
                        {viewEdit && <h4>
                            {renderHTML(userName)}
                        </h4>}
                    </div>
                    <div className="controls">
                        {!viewTick && <i className="done"
                            onClick={(e) => handleVcardSaveUsername()}
                        ><CustomIcon icon={mf_Done ? mf_Done : <DoneHoc viewBox="0 0 14 10"/>} {...props} /></i>}
                        {viewEdit && <i className="edit" onClick={(e) => handleEdit()}><CustomIcon icon={mf_Edit ? mf_Edit : <EditHoc  viewBox="0 0 18 18"/>} {...props} /></i>}
                    </div>
                </div>
                {/* <label className="">{YOUR_STATUS}</label>
                <div className="profile-details status" title="Edit status">
                    <i className="status"><CustomIcon icon={mf_Status ? mf_Status : <StatusHoc />} {...props} /></i>
                    <div className="form-control">
                        {!viewEditStatus &&
                            <input
                                type="text"
                                value={userStatus}
                                autoComplete="off"
                                placeholder="Status"
                                id="status"
                                name="userStatus"
                                onChange={handleWordCountStatus}
                                // maxLength={findNegativeValue(userStatus, REACT_APP_STATUS_CHAR) > 0 ? 1000 : 0}
                                maxLength={REACT_APP_STATUS_CHAR}
                                autoFocus
                                // onMouseUp={(e) => {
                                //     userStatusCursorPostion = e.target.selectionStart;
                                // }}
                                // onKeyUp={(e) => {
                                //     userStatusCursorPostion = e.target.selectionStart;
                                // }}
                                // onBlur={(e) => {
                                //     userStatusSelectedText = getSelectedText();
                                // }}
                            ></input>}
                        {charCountStatus && <span className="char-count">
                            {statusChars}
                        </span>}
                        {viewEditStatus && <h4>
                            {renderHTML(userStatus)}
                        </h4>}
                    </div>
                    <div className="controls">
                        {!viewTickStatus && <i className="done"
                            onClick={(e) => handleVcardSaveStatus()}
                        ><CustomIcon icon={mf_Done ? mf_Done : <DoneHoc viewBox="0 0 14 10"/>} {...props} /></i>}
                        {viewEditStatus &&
                            <i className="edit" onClick={(e) => handleEditStatus()}> <CustomIcon icon={mf_Edit ? mf_Edit : <EditHoc viewBox="0 0 18 18"/>} {...props} />
                            </i>}
                    </div>
                </div> */}
                <label className="">Email Address</label>
                <div className="profile-details status" title="Edit status">
                    <i className="status"><CustomIcon icon={mf_Status ? mf_Status : <StatusHoc />} {...props} /></i>
                    <div className="form-control">
                        {!viewEditEmail &&
                            <input
                                type="text"
                                value={userEmail}
                                autoComplete="off"
                                placeholder="Email Address"
                                id="email"
                                name="userEmail"
                                onChange={handleWordCountEmail}
                                // maxLength={findNegativeValue(userStatus, REACT_APP_STATUS_CHAR) > 0 ? 1000 : 0}
                                maxLength={REACT_APP_STATUS_CHAR}
                                autoFocus
                                // onMouseUp={(e) => {
                                //     userStatusCursorPostion = e.target.selectionStart;
                                // }}
                                // onKeyUp={(e) => {
                                //     userStatusCursorPostion = e.target.selectionStart;
                                // }}
                                // onBlur={(e) => {
                                //     userStatusSelectedText = getSelectedText();
                                // }}
                            ></input>}
                        {charCountEmail && 
                            <span className="char-count">
                                {statusChars}
                            </span>
                        }
                        {viewEditEmail && <h4>{renderHTML(userEmail)}</h4>}
                    </div>
                    <div className="controls">
                        {!viewTickEmail && 
                            <i className="done" onClick={(e) => handleVcardSaveEmail()}>
                                <CustomIcon icon={mf_Done ? mf_Done : <DoneHoc viewBox="0 0 14 10"/>} {...props} />
                            </i>
                        }
                        {viewEditEmail &&
                            <i className="edit" onClick={(e) => handleEditEmail()}> <CustomIcon icon={mf_Edit ? mf_Edit : <EditHoc viewBox="0 0 18 18"/>} {...props} />
                            </i>
                        }
                    </div>
                </div>
                <label className="">Mobile Number</label>
                <div className="profile-details status" title="Edit status">
                    <i className="status"><CustomIcon icon={mf_Status ? mf_Status : <StatusHoc />} {...props} /></i>
                    <div className="form-control">
                        {!viewEditMobile &&
                            <input
                                type="text"
                                value={userMobile}
                                autoComplete="off"
                                placeholder="Mobile"
                                id="mobile"
                                name="userMobile"
                                onChange={handleWordCountMobile}
                                // maxLength={findNegativeValue(userStatus, REACT_APP_STATUS_CHAR) > 0 ? 1000 : 0}
                                maxLength={REACT_APP_STATUS_CHAR}
                                autoFocus
                                // onMouseUp={(e) => {
                                //     userStatusCursorPostion = e.target.selectionStart;
                                // }}
                                // onKeyUp={(e) => {
                                //     userStatusCursorPostion = e.target.selectionStart;
                                // }}
                                // onBlur={(e) => {
                                //     userStatusSelectedText = getSelectedText();
                                // }}
                            ></input>}
                        {charCountMobile && 
                            <span className="char-count">
                                {statusChars}
                            </span>
                        }
                        {viewEditMobile && <h4> {renderHTML(userMobile)}</h4>}
                    </div>
                    <div className="controls">
                        {!viewTickMobile && 
                            <i className="done" onClick={(e) => handleVcardSaveMobile()}>
                                <CustomIcon icon={mf_Done ? mf_Done : <DoneHoc viewBox="0 0 14 10"/>} {...props} />
                            </i>
                        }
                        {/** {viewEditMobile &&
                            <i className="edit" onClick={(e) => handleEditMobile()}> <CustomIcon icon={mf_Edit ? mf_Edit : <EditHoc viewBox="0 0 18 18"/>} {...props} />
                            </i>
                        } */}
                    </div>
                </div>
                <div className="info">
                    <i><CustomIcon icon={mf_InfoIcon ? mf_InfoIcon : <InfoIconHoc />} {...props} /> </i>
                    <span>{VIEW_PROFILE_INFO}</span>
                </div>
            </div>
        </>
    );
};

export default WebChatFields;
